import React from 'react';

const ActionBarCount = ({ totalResults, selectedCount, type }) => {
  const renderCount = () => {
    if (!totalResults)
      return t('archive.bulk_actions.no_archivable_found', { type });

    if (selectedCount)
      return t('archive.bulk_actions.selected', { count: selectedCount, type });

    return t('archive.bulk_actions.archive', { count: totalResults, type });
  };

  return <span>{renderCount()}</span>;
};

export default ActionBarCount;
